import { override } from 'flarum/common/extend';
import RenameDiscussionModal from 'flarum/forum/components/RenameDiscussionModal';

/**
 * The rename modal opens with the caret after the title, not the whole title
 * selected (core's FormModal::onready()): renaming is mostly fixing a word,
 * and on an iPad a selected title couldn't even be deselected without
 * cutting and pasting it back (castor74, 2026-11-02).
 */
export default function keepRenamedTitleUnselected() {
  override(RenameDiscussionModal.prototype, 'onready', function () {
    const input = this.$().find('input').first()[0];
    if (!input) return;
    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
  });
}